document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('.ss-pdp__form');
    if (!form) return;
    const qtyInput = form.querySelector('[data-qty-input]');
    const qtyDisplay = form.querySelector('[data-qty-display]');
    const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    const planSelect = form.querySelector('[data-selling-plan-select]');
    const subscriptionPrice = section.querySelector('[data-subscription-price]');
    const subscriptionDiscount = section.querySelector('[data-subscription-discount]');
    const dailyPriceDisplay = section.querySelector('[data-daily-price-display]');
    const quantityMeta = section.querySelector('[data-master-quantity]');
    const supplyDisplay = section.querySelector('[data-summary-supply]');
    const supplyValueDisplay = section.querySelector('[data-summary-supply-value]');
    const supplyUnitDisplay = section.querySelector('[data-summary-supply-unit]');
    const capsuleDisplay = section.querySelector('[data-capsule-display]');
    const rewardPointsDisplay = section.querySelector('[data-reward-points]');
    const pointsNote = section.querySelector('[data-points-note]');
    const daysPerUnit = Number(section.dataset.daysPerUnit || 0);
    const capsulesPerUnit = Number(section.dataset.capsuleCount || 0);
    const rewardPointsPerUnit = Number(rewardPointsDisplay?.textContent.replace(/\D/g, '') || 0);

    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const setQuantity = (qty) => {
      qty = Math.max(1, Number(qty) || 1);
      qtyInput.value = qty;
      if (qtyDisplay) qtyDisplay.textContent = qty;
      let activeBundleOption = null;
      section.querySelectorAll('[data-bundle-option]').forEach((el) => {
        const isActive = Number(el.dataset.qty) === qty;
        el.classList.toggle('is-selected', isActive);
        if (isActive) activeBundleOption = el;
      });
      if (quantityMeta) quantityMeta.textContent = `Menge: ${qty} ${qty === 1 ? 'Dose' : 'Dosen'}`;
      if (supplyDisplay && daysPerUnit > 0) {
        const months = Math.max(1, Math.round((daysPerUnit * qty) / 30));
        if (supplyValueDisplay && supplyUnitDisplay) {
          supplyValueDisplay.textContent = months;
          supplyUnitDisplay.textContent = months === 1 ? 'Monat' : 'Monate';
        } else {
          supplyDisplay.textContent = `${months} ${months === 1 ? 'Monat' : 'Monate'}`;
        }
      }
      if (capsuleDisplay && capsulesPerUnit > 0) capsuleDisplay.textContent = capsulesPerUnit * qty;
      if (rewardPointsDisplay && rewardPointsPerUnit > 0) rewardPointsDisplay.textContent = `+${rewardPointsPerUnit * qty}`;
      if (pointsNote && rewardPointsPerUnit > 0) pointsNote.textContent = `${rewardPointsPerUnit * qty} Punkte`;
      if (dailyPriceDisplay && activeBundleOption?.dataset.dailyPrice) {
        dailyPriceDisplay.textContent = `Nur ${money(Number(activeBundleOption.dataset.dailyPrice))} pro Tag`;
      }
    };

    section.querySelectorAll('[data-bundle-option]').forEach((el) => {
      const qty = Number(el.dataset.qty || 1);
      el.addEventListener('click', () => setQuantity(qty));
    });

    const updateSellingPlan = () => {
      const option = planSelect?.selectedOptions[0];
      if (!option) return;
      const isSubscription = Boolean(section.querySelector('[data-purchase-option="subscription"] input:checked'));
      if (sellingPlanInput) sellingPlanInput.value = isSubscription ? option.value : '';
      if (subscriptionPrice && option.dataset.price) subscriptionPrice.textContent = `${money(Number(option.dataset.price))} / Lieferung`;
      if (subscriptionDiscount) {
        const discount = Number(option.dataset.discount || 0);
        subscriptionDiscount.textContent = discount > 0 ? `${discount}% Rabatt` : '';
      }
    };

    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQuantity(Number(qtyInput.value) - 1));
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQuantity(Number(qtyInput.value) + 1));

    section.querySelectorAll('[data-purchase-option]').forEach((label) => {
      label.addEventListener('click', () => {
        if (label.classList.contains('is-disabled')) return;
        section.querySelectorAll('[data-purchase-option]').forEach((x) => x.classList.remove('is-selected'));
        label.classList.add('is-selected');
        const isSub = label.dataset.purchaseOption === 'subscription';
        if (sellingPlanInput) sellingPlanInput.value = isSub && planSelect ? planSelect.value : '';
        updateSellingPlan();
      });
    });
    planSelect?.addEventListener('change', updateSellingPlan);

    section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      section.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      section.querySelectorAll('[data-gallery-media]').forEach((m) => m.classList.toggle('is-hidden', m.dataset.galleryMedia !== thumb.dataset.mediaId));
      if (window.matchMedia('(min-width: 991px)').matches) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }));

    section.querySelectorAll('[data-tab]').forEach((tab) => tab.addEventListener('click', () => {
      const key = tab.dataset.tab;
      section.querySelectorAll('[data-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
      section.querySelectorAll('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.panel === key));
    }));

    setQuantity(qtyInput.value);
  });
});
